<template>
  <div v-if="mesFacturacion">
    <v-container fluid grid-list-xs>
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <Boton :id="'btnNew' + baseCotizacion" :onclick="newClick">{{
          $t('message.cuotas.periodo.anadir' + this.baseCotizacion)
        }}</Boton>
      </v-toolbar>
      <v-data-table
        :id="id"
        :headers="fields"
        :items="data"
        :no-data-text="$t('message.cuotas.periodo.sinPeriodos')"
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <!-- <td class="text-xs-left">{{ props.item.nombre }}</td> -->
          <td class="text-xs-center">{{ props.item.periodoConsumo | moment('DD-MMMM-YYYY') }}</td>
          <td class="text-xs-right" v-if="isTarifa">
            <Numeric
              :id="'facturacion' + props.item.id"
              v-model="props.item.facturacion"
              :readonly="true"
            ></Numeric>
          </td>
          <td class="text-xs-right">
            <Numeric
              :id="'nukwhfac' + props.item.id"
              v-model="props.item.nukwhfac"
              :precision="0"
              :readonly="true"
            ></Numeric>
          </td>
          <td class="text-xs-right">
            <Numeric
              :id="'base' + props.item.id"
              v-model="props.item.baseImponible"
              :readonly="true"
            ></Numeric>
          </td>

          <td class="text-xs-center">
            <Icono
              :id="'editar' + baseCotizacion + props.item.id"
              :payload="props.item"
              color="info"
              class="mr-2"
              :tooltip="$t('message.cuotas.periodo.modificar' + baseCotizacion)"
              @click="editClick"
              >edit</Icono
            >
            <Icono
              :id="'eliminar' + baseCotizacion + props.item.id"
              :payload="props.item"
              color="error"
              :tooltip="$t('message.cuotas.periodo.eliminar')"
              @click="removeClick"
              >delete</Icono
            >
          </td>
        </template>
      </v-data-table>
    </v-container>

    <!-- Info modal -->
    <Modal id="modalPeriodo" :modalShow="modalShow" size="900" :title="modalTitle">
      <PeriodoElecCuota
        :model="rowSelected"
        :mesFacturacion="mesFacturacion"
        :isTarifa="isTarifa"
        :mode="mode"
        @modify="modificarHandler"
        @cancel="cancelarHandler"
      ></PeriodoElecCuota>
    </Modal>
  </div>
</template>
<script>
import { Numeric, Boton, Modal, CampoSelect, Icono } from '@/components';
import PeriodoElecCuota from './PeriodoElecCuota';
import {
  BASECOTIZACION_CUOTAS,
  PERIODO_CUOTA_ELEC_INIT,
  CUOTAS_ELEC_INIT,
  ID_CUOTA_ELEC_EXTRA,
  ID_CUOTA_ELEC_OS,
  ID_CUOTA_ELEC_OM,
  ID_CUOTA_ELEC_INTER,
  ID_CUOTA_ELEC_RECARGO,
  ID_CUOTA_ELEC_MORA
} from '../cuotasConst';
import { notificarWarning } from '@/utils/notification';
export default {
  name: 'periodosElecCuotas',
  props: {
    id: {
      type: String,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    mesFacturacion: {
      type: Date
    },
    baseCotizacion: {
      // peaje o gas
      type: Number,
      required: true
    }
  },
  components: {
    Numeric,
    Boton,
    Modal,
    CampoSelect,
    PeriodoElecCuota,
    Icono
  },
  data() {
    let fields = [
      {
        value: 'periodo',
        text: this.$t('message.cuotas.periodo.periodo'),
        align: 'center',
        sortable: false
      },
      {
        value: 'facturacion',
        text: this.$tc('message.cuotas.periodo.facturacion', 2),
        align: 'right',
        sortable: false
      },
      {
        value: 'nukwhfac',
        text: this.$t('message.cuotas.periodo.nukwhfac'),
        align: 'right',
        sortable: false
      },
      {
        value: 'base',
        text: this.$tc('message.cuotas.periodo.base', 2),
        align: 'right',
        sortable: false
      },
      {
        value: 'actions',
        text: this.$t('message.tasas.periodo.actions'),
        align: 'center',
        sortable: false
      }
    ];
    return { mode: 'new', rowSelected: {}, modalShow: false, fields: fields, precisionTipo: 3 };
  },
  computed: {
    isTarifa() {
      return this.baseCotizacion === BASECOTIZACION_CUOTAS.TARIFA;
    },
    modalTitle() {
      return this.mode === 'new'
        ? this.$t('message.cuotas.periodo.anadir' + this.baseCotizacion)
        : this.$t('message.cuotas.periodo.modificar' + this.baseCotizacion);
    }
  },
  methods: {
    // Acciones tabla
    newClick() {
      this.mode = 'new';
      Object.assign(this.rowSelected, PERIODO_CUOTA_ELEC_INIT);
      this.rowSelected.idBaseCo = this.baseCotizacion;
      this.rowSelected.id = this.data.length + 1;
      this.rowSelected.cuotas = [];
      for (let id of [
        ID_CUOTA_ELEC_EXTRA,
        ID_CUOTA_ELEC_OS,
        ID_CUOTA_ELEC_OM,
        ID_CUOTA_ELEC_INTER,
        ID_CUOTA_ELEC_RECARGO,
        ID_CUOTA_ELEC_MORA
      ]) {
        let cuota = {};
        Object.assign(cuota, CUOTAS_ELEC_INIT);
        cuota.id = id;
        this.rowSelected.cuotas.push(cuota);
      }

      this.modalShow = true;
    },
    editClick(item) {
      this.mode = 'modify';
      this.rowSelected = item;
      this.modalShow = true;
    },
    removeClick(item) {
      this.$emit('remove', item);
    },
    // Acciones dialogo
    modificarHandler(payload) {
      // Checkeamos pk única
      var index = this.data.findIndex(function(item) {
        return (
          item.id != payload.id &&
          item.periodoConsumo.getTime() === payload.periodoConsumo.getTime()
        );
      });
      if (index === -1) {
        this.$emit('modify', payload);
        this.rowSelected = {};
        this.modalShow = false;
      } else {
        ++index;
        notificarWarning(
          this,
          'Periodo duplicado',
          'El periodo ha sido elegido en la fila '.concat(index.toString())
        );
      }
    },
    cancelarHandler() {
      this.rowSelected = {};
      this.modalShow = false;
    }
  },
  created() {
    if (!this.isTarifa) {
      // Ocultamos las columnas que no nos interesan
      this.fields.splice(1, 1);
    }
  }
};
</script>
